import type { AllRouteEndpoints } from "../routeTypes";

export const postApiCalculatedFiltersIdAppGroupIdRefreshCacheKeys: AllRouteEndpoints[] = [
  "/api/calculated_filters/:app_group_id",
];
